import {
  createBrowserRouter,
  createHashRouter,
  Navigate,
} from "react-router-dom";
import AuthGuard from "@/components/AuthGuard";
import MainLayout from "@/layouts/MainLayout";
import AppDetailLayout from "@/layouts/AppDetailLayout";
import Workbench from "@/pages/workbench";
import DeveloperInfo from "@/pages/account/DeveloperInfo";
import AccountLayout from "@/pages/account/Settlements/AccountLayout";
import Settlements from "@/pages/account/Settlements";
import SettlementDetail from "@/pages/account/Settlements/Detail";
import Products from "@/pages/app-detail/Products";
import Versions from "@/pages/app-detail/Versions";
import Credentials from "@/pages/app-detail/Credentials";
import Scope from "@/pages/app-detail/Scope";
import Events from "@/pages/app-detail/Events/index";
import Security from "@/pages/app-detail/Security";
import LoginPage from "@/pages/Login";
import NotFound from "@/pages/NotFound";
import RouteErrorPage from "@/pages/RouteErrorPage";
import { detectRuntime } from "@/store/useRuntimeStore";

const routes = [
  { path: "/login", element: <LoginPage />, errorElement: <RouteErrorPage /> },
  {
    element: <AuthGuard />,
    errorElement: <RouteErrorPage />,
    children: [
      {
        path: "/",
        element: <MainLayout />,
        children: [
          { index: true, element: <Navigate to="/apps" replace /> },
          { path: "apps", element: <Workbench /> },
          { path: "developer", element: <DeveloperInfo /> },
        ],
      },
      {
        path: "/apps/:app_id",
        element: <AppDetailLayout />,
        children: [
          { index: true, element: <Navigate to="credentials" replace /> },
          { path: "versions", element: <Versions /> },
          { path: "credentials", element: <Credentials /> },
          { path: "scope", element: <Scope /> },
          { path: "events", element: <Events /> },
          { path: "security", element: <Security /> },
          { path: "products", element: <Products /> },
          {
            path: "account",
            element: <AccountLayout />,
            children: [
              { index: true, element: <DeveloperInfo /> },
              { path: "settlements", element: <Settlements /> },
              {
                path: "settlements/statements/:statementId",
                element: <SettlementDetail />,
              },
            ],
          },
        ],
      },
    ],
  },
  { path: "*", element: <NotFound />, errorElement: <RouteErrorPage /> },
];

/** 嵌在客户端时用 hash，避免和宿主 history 抢路由。 */
export const router =
  detectRuntime() === "client"
    ? createHashRouter(routes)
    : createBrowserRouter(routes);
